import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { css } from '@emotion/react';
import { akEditorFloatingDialogZIndex, akEditorMobileMaxWidth, akEditorSwoopCubicBezier, akEditorToolbarKeylineHeight } from '@atlaskit/editor-shared-styles';
export var MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 868;
var toolbarLineHeight = 56;

// box-shadow is overriden by the mainToolbar
var mainToolbarWithKeyline = css({
  boxShadow: "0 ".concat(akEditorToolbarKeylineHeight, "px 0 0 ", "var(--ds-background-accent-gray-subtlest, #F1F2F4)")
});
var mainToolbarTwoLineStyle = css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
  flexWrap: 'wrap',
  height: "calc(".concat(toolbarLineHeight, "px * 2)")
}));
var mainToolbar = css(_defineProperty({
  position: 'relative',
  alignItems: 'center',
  boxShadow: 'none',
  transition: "box-shadow 200ms ".concat(akEditorSwoopCubicBezier),
  zIndex: akEditorFloatingDialogZIndex,
  display: 'flex',
  height: "".concat(toolbarLineHeight, "px"),
  flexShrink: 0,
  backgroundColor: "var(--ds-surface, white)",
  '& object': {
    height: '0 !important'
  }
}, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
  display: 'grid',
  height: "calc(".concat(toolbarLineHeight, "px * 2)")
}));
export var mainToolbarStyle = function mainToolbarStyle(showKeyline, twoLineEditorToolbar) {
  return [mainToolbar, showKeyline && mainToolbarWithKeyline, twoLineEditorToolbar && mainToolbarTwoLineStyle];
};
export var mainToolbarIconBeforeStyle = css(_defineProperty({
  margin: "var(--ds-space-200, 16px)",
  height: "var(--ds-space-400, 32px)",
  width: "var(--ds-space-400, 32px)"
}, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
  gridColumn: 1,
  gridRow: 1
}));
var mainToolbarFirstChild = css(_defineProperty({
  display: 'flex',
  flexGrow: 1
}, "@media (max-width: ".concat(akEditorMobileMaxWidth, "px)"), {
  gridColumn: 1,
  gridRow: 1
}));
var mainToolbarFirstChildTowLine = css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
  flex: '1 1 100%',
  height: "".concat(toolbarLineHeight, "px"),
  justifyContent: 'flex-end',
  minWidth: 'fit-content'
}));
export var mainToolbarFirstChildStyle = function mainToolbarFirstChildStyle(twoLineEditorToolbar) {
  return [mainToolbarFirstChild, twoLineEditorToolbar && mainToolbarFirstChildTowLine];
};
var mainToolbarSecondChild = css({
  minWidth: 'fit-content'
});
var mainToolbarSecondChildTwoLine = css(_defineProperty({}, "@media (max-width: ".concat(MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT, "px)"), {
  display: 'flex',
  flexGrow: 1,
  flex: '1 1 100%',
  margin: 'auto',
  height: "".concat(toolbarLineHeight, "px"),
  minWidth: 0
}));
export var mainToolbarSecondChildStyle = function mainToolbarSecondChildStyle(twoLineEditorToolbar) {
  return [mainToolbarSecondChild, twoLineEditorToolbar && mainToolbarSecondChildTwoLine];
};
export var nonCustomToolbarWrapperStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1
});
export var customToolbarWrapperStyle = css({
  alignItems: 'center',
  display: 'flex'
});